import React from 'react';
import { infoPageStyles as styles } from './sharedStyles';

const CommunityGuidelines = () => {
  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Community Guidelines</h1>
        <p style={styles.headerSubtitle}>
          Building a safe and respectful marketplace
        </p>
      </div>

      <div style={styles.contentContainer}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Our Commitment</h2>
          <p style={styles.text}>
            Redbird Markets is built on trust, respect, and community. These guidelines help ensure 
            a positive experience for all ISU community members.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Core Values</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Respect:</strong> Treat all users with courtesy and dignity</li>
            <li style={styles.listItem}><strong>Honesty:</strong> Be truthful in all listings and communications</li>
            <li style={styles.listItem}><strong>Safety:</strong> Prioritize the safety and security of all users</li>
            <li style={styles.listItem}><strong>Integrity:</strong> Act ethically and follow platform rules</li>
            <li style={styles.listItem}><strong>Community:</strong> Support and help fellow ISU members</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Acceptable Use</h2>
          <h3 style={styles.subsectionTitle}>✅ Do</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Be honest about item condition and features</li>
            <li style={styles.listItem}>Respond to messages promptly and professionally</li>
            <li style={styles.listItem}>Honor your commitments and agreements</li>
            <li style={styles.listItem}>Meet in safe, public locations</li>
            <li style={styles.listItem}>Report suspicious or inappropriate behavior</li>
            <li style={styles.listItem}>Price items fairly</li>
            <li style={styles.listItem}>Update listings promptly when sold</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Prohibited Conduct</h2>
          <h3 style={styles.subsectionTitle}>❌ Don't</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Post false, misleading, or deceptive listings</li>
            <li style={styles.listItem}>Harass, threaten, or intimidate other users</li>
            <li style={styles.listItem}>Discriminate based on race, religion, gender, or other protected characteristics</li>
            <li style={styles.listItem}>Use profane, offensive, or inappropriate language</li>
            <li style={styles.listItem}>Engage in spam or irrelevant communications</li>
            <li style={styles.listItem}>Create fake accounts or impersonate others</li>
            <li style={styles.listItem}>Attempt to circumvent platform fees</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Prohibited Items</h2>
          <p style={styles.text}>The following items may NOT be listed on Redbird Markets:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Illegal substances or drug paraphernalia</li>
            <li style={styles.listItem}>Weapons, ammunition, or explosives</li>
            <li style={styles.listItem}>Stolen, counterfeit, or replica goods</li>
            <li style={styles.listItem}>Event tickets not permitted by university policy</li>
            <li style={styles.listItem}>Digital downloads or intangible goods (unless approved)</li>
            <li style={styles.listItem}>Alcohol or tobacco products</li>
            <li style={styles.listItem}>Prescription medications or medical devices</li>
            <li style={styles.listItem}>Adult content or services</li>
            <li style={styles.listItem}>Live animals</li>
            <li style={styles.listItem}>Hazardous materials</li>
            <li style={styles.listItem}>Academic dishonesty items (e.g., completed assignments, essay services)</li>
            <li style={styles.listItem}>Items that violate copyright, trademark, or intellectual property laws</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Payment and Transaction Rules</h2>
          <div style={styles.highlight}>
            <h3 style={styles.subsectionTitle}>ALL SALES ARE FINAL</h3>
            <p style={styles.text}>
              <strong>Once payment is completed, all sales are final.</strong> There are no refunds, returns, or exchanges 
              through Redbird Markets. Buyers must inspect items thoroughly before purchasing. Payment disputes must be handled 
              through Stripe and your card issuer.
            </p>
          </div>
          
          <h3 style={styles.subsectionTitle}>Off-Platform Payments Warning</h3>
          <div style={styles.highlight}>
            <p style={styles.text}>
              <strong>WARNING:</strong> Any payments made outside of Stripe (cash, Venmo, Zelle, PayPal, etc.) are completely 
              at your own risk. Redbird Markets provides NO protection, dispute resolution, or support for off-platform transactions. 
              Users accepting off-platform payments violate these guidelines and forfeit all platform protections.
            </p>
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Safety and Meeting Guidelines</h2>
          <div style={styles.highlight}>
            <p style={styles.text}>
              <strong>CRITICAL:</strong> Meet ONLY in public, well-lit areas on ISU campus. NEVER meet at private residences or isolated locations.
            </p>
          </div>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Recommended Locations:</strong> Bone Student Center, Milner Library, Student Services Building</li>
            <li style={styles.listItem}>Bring a friend or notify someone of meeting details</li>
            <li style={styles.listItem}>Meet during daylight hours when possible</li>
            <li style={styles.listItem}>Inspect items thoroughly before payment/exchange</li>
            <li style={styles.listItem}>Trust your instincts - if something feels wrong, cancel</li>
            <li style={styles.listItem}>Contact ISU Police (438-8631) for suspicious behavior</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Communication Standards</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>Use respectful and professional language</li>
            <li style={styles.listItem}>Keep all communications on the platform</li>
            <li style={styles.listItem}>Respond to inquiries within 24-48 hours</li>
            <li style={styles.listItem}>Be clear and specific in all messages</li>
            <li style={styles.listItem}>Don't share personal contact information publicly</li>
            <li style={styles.listItem}>Report inappropriate messages immediately</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Consequences of Violations</h2>
          <p style={styles.text}>
            Violations of these guidelines may result in:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>First Violation:</strong> Warning and listing removal</li>
            <li style={styles.listItem}><strong>Second Violation:</strong> Temporary account suspension (7-30 days)</li>
            <li style={styles.listItem}><strong>Third Violation or Serious Violations:</strong> Permanent account ban with NO appeal</li>
            <li style={styles.listItem}><strong>Illegal Activity:</strong> Immediate permanent ban and report to authorities</li>
          </ul>
          
          <div style={styles.highlight}>
            <p style={styles.text}>
              <strong>Serious violations</strong> (fraud, threats, stolen goods, illegal items, harassment) will be reported to:
            </p>
            <ul style={styles.list}>
              <li style={styles.listItem}>Illinois State University Dean of Students Office</li>
              <li style={styles.listItem}>ISU Police Department</li>
              <li style={styles.listItem}>Local law enforcement (as appropriate)</li>
            </ul>
            <p style={styles.text}>
              By using Redbird Markets, you consent to the sharing of relevant information with university officials and 
              law enforcement when necessary to investigate violations or ensure campus safety.
            </p>
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Reporting Violations</h2>
          <p style={styles.text}>
            If you encounter behavior that violates these guidelines:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Provide detailed information about the violation</li>
            <li style={styles.listItem}>Include screenshots if applicable</li>
            <li style={styles.listItem}>Contact us through the <a href="/report-issue" style={styles.link}>Report Issue</a> page</li>
          </ul>
          <div style={styles.highlight}>
            <p style={styles.text}>
              We take all reports seriously and investigate them promptly. Your identity will be kept confidential.
            </p>
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Updates to Guidelines</h2>
          <p style={styles.text}>
            These guidelines may be updated periodically. Continued use of Redbird Markets constitutes 
            acceptance of any changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommunityGuidelines;
